/**
 * FAQ Service
 */
import { getApiClient } from '../apiClient';
import { FAQ_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetFaqsResponse,
  GetFaqResponse,
  CreateFaqPayload,
  CreateFaqResponse,
  UpdateFaqPayload,
  UpdateFaqResponse,
  DeleteFaqResponse,
  GetFaqsParams,
} from '../types/faq.types';

export const faqService = {
  /**
   * Get all FAQs
   */
  getFaqs: (params?: GetFaqsParams): Promise<GetFaqsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    const url = queryParams.toString() 
      ? `${FAQ_ENDPOINTS.getFaqs}?${queryParams.toString()}`
      : FAQ_ENDPOINTS.getFaqs;
    return getApiClient().get(url);
  },

  /**
   * Get single FAQ by ID
   */
  getFaq: (id: string): Promise<GetFaqResponse> => {
    const url = replacePathParams(FAQ_ENDPOINTS.getFaq, { id });
    return getApiClient().get(url);
  },

  /**
   * Create new FAQ
   */
  createFaq: (body: CreateFaqPayload): Promise<CreateFaqResponse> => {
    return getApiClient().post(FAQ_ENDPOINTS.createFaq, body);
  },

  /**
   * Update FAQ
   */
  updateFaq: (id: string, body: UpdateFaqPayload): Promise<UpdateFaqResponse> => {
    const url = replacePathParams(FAQ_ENDPOINTS.updateFaq, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete FAQ
   */
  deleteFaq: (id: string): Promise<DeleteFaqResponse> => {
    const url = replacePathParams(FAQ_ENDPOINTS.deleteFaq, { id });
    return getApiClient().delete(url);
  },
};

